import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUrl } from '../../../data-services/stores/selectors/router.selectors';
import { AsyncPipe } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { selectAdminMenuVisibility } from '../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../data-services/stores/actions/admin.actions';

@Component({
  selector: 'app-admin-menu',
  imports: [AsyncPipe,RouterModule,DrawerModule],
  templateUrl: '../ui/admin-menu.component.html',
  styleUrl: '../ui/admin-menu.component.css'
})
export class AdminMenuComponent implements OnInit {
  private readonly _router = inject(Router)
  private readonly _store = inject(Store);
  routerUrl$ = this._store.select(selectUrl);
  visible$ = this._store.select(selectAdminMenuVisibility)

  ngOnInit(): void {
    this._router.events.subscribe((val) => {
      if (val instanceof NavigationEnd){
        this.onHide();
      }
    })
  }

  onHide(){
    this._store.dispatch(adminActions.changeMenuVisiblity({visibility:false}))
  }
}
